module.exports = __webpack_public_path__ + "img/churchplus-giva-min.a8489675.png";